import { useEffect, useState } from "react";
import { TemplatesTransport } from "src/app/transports/templates";
import { LangType } from "src/app/types/LangType";
import { Template } from "src/app/types/templates";

const useTemplateList = (initialLang: LangType) => {
    const [templateList, setTemplateList] = useState<Array<Template>>();
    const [error, setError] = useState<any>();
    const [loading, setLoading] = useState(false);

    const fetch = (lang: LangType) => {
        setLoading(true);
        TemplatesTransport.findAll(lang)
            .then((res) => {
                setTemplateList(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (lang: LangType) => {
        if (!loading) fetch(lang);
    };

    useEffect(() => {
        fetch(initialLang);
    }, []);

    return { templateList, loading, error, refresh };
};

export default useTemplateList;
